import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import { PartnerAuthProvider } from "./context/PartnerAuthContext";
import { useDynamicBranding } from "./hooks/useDynamicBranding";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/HomePage";
import CRMPage from "./pages/CRMPage";
import AIPage from "./pages/AIPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceCategoryPage from "./pages/ServiceCategoryPage";
import ServiceProviderDetailPage from "./pages/ServiceProviderDetailPage";
import ProductsPage from "./pages/ProductsPage";
import ProductsCatalogPage from "./pages/ProductsCatalogPage";
import CategoryPage from "./pages/CategoryPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import FavoritesPage from "./pages/FavoritesPage";
import AdminTasksPage from "./pages/AdminTasksPage";
import PartnerProfilePage from "./pages/PartnerProfilePage";
import PartnerSitePage from "./pages/PartnerSitePage";
import TemplatePreviewPage from "./pages/TemplatePreviewPage";
import PartnerLoginPage from "./pages/PartnerLoginPage";
import PartnerRegisterPage from "./pages/PartnerRegisterPage";
import PartnerDashboardPage from "./pages/PartnerDashboardPage";
import PartnerProductPage from "./pages/PartnerProductPage";
import PartnersPlansPage from "./pages/PartnersPlansPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentResultPage from "./pages/PaymentResultPage";
import RochaAdminPage from "./pages/RochaAdminPage";
import AugAdminPage from "./pages/AugAdminPage";

function AppRoutes() {
  useDynamicBranding();
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/:country" element={<HomePage />} />
      <Route path="/:country/crm" element={<CRMPage />} />
      <Route path="/:country/ai" element={<AIPage />} />
      <Route path="/:country/services" element={<ServicesPage />} />
      <Route path="/:country/services/category/:categorySlug" element={<ServiceCategoryPage />} />
      <Route path="/:country/services/:providerId" element={<ServiceProviderDetailPage />} />
      <Route path="/:country/products" element={<ProductsPage />} />
      <Route path="/:country/products/catalog" element={<ProductsCatalogPage />} />
      <Route path="/:country/products/category/:categorySlug" element={<CategoryPage />} />
      <Route path="/:country/products/:productId" element={<ProductDetailPage />} />
      <Route path="/:country/favorites" element={<FavoritesPage />} />
      <Route path="/:country/admin/tasks" element={<AdminTasksPage />} />
      <Route path="/:country/partner-plans" element={<PartnersPlansPage />} />
      <Route path="/:country/partner/:partnerId" element={<PartnerProfilePage />} />
      <Route path="/parceiros/:slug" element={<PartnerSitePage />} />
      <Route path="/parceiros/:slug/produto/:productId" element={<PartnerProductPage />} />
      <Route path="/parceiros/:slug/checkout" element={<CheckoutPage />} />
      <Route path="/parceiros/:slug/pagamento/:status" element={<PaymentResultPage />} />
      <Route path="/parceiros/rocha/admin" element={<RochaAdminPage />} />
      <Route path="/aug/admin" element={<AugAdminPage />} />
      <Route path="/templates" element={<TemplatePreviewPage />} />
      <Route path="/parceiro/login" element={<PartnerLoginPage />} />
      <Route path="/parceiro/cadastro" element={<PartnerRegisterPage />} />
      <Route path="/parceiro/dashboard" element={<PartnerDashboardPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <CartProvider>
        <FavoritesProvider>
          <PartnerAuthProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </PartnerAuthProvider>
        </FavoritesProvider>
      </CartProvider>
    </div>
  );
}

export default App;
